import { v4 as uuidv4 } from 'uuid';

interface TempImage {
  id: string;
  file: File;
  url: string;
}

class ImageStorageService {
  private tempImages: Map<string, TempImage> = new Map();

  async createTempImage(file: File): Promise<TempImage> {
    const id = uuidv4();
    const url = URL.createObjectURL(file);
    const tempImage = { id, file, url };
    this.tempImages.set(id, tempImage);
    return tempImage;
  }

  getTempImage(id: string): TempImage | undefined {
    return this.tempImages.get(id);
  }

  getAllTempImages(): TempImage[] {
    return Array.from(this.tempImages.values());
  }

  removeTempImage(id: string): void {
    const image = this.tempImages.get(id);
    if (image) {
      URL.revokeObjectURL(image.url);
      this.tempImages.delete(id);
    }
  }

  clearAllTempImages(): void {
    this.tempImages.forEach(image => {
      URL.revokeObjectURL(image.url);
    });
    this.tempImages.clear();
  }
}

export const imageStorage = new ImageStorageService();